import { z } from 'zod';
export const notificationKind = z.enum([
    'project_assigned',
    'project_status_change',
    'mention',
    'mail_suggestion',
    'deadline_approaching',
    'field_suggestion',
    'version_created',
    'comment_added',
]);
export const notificationListQuery = z.object({
    unreadOnly: z.coerce.boolean().default(false),
    limit: z.coerce.number().int().positive().max(100).default(50),
});
